import { Observable } from 'rxjs';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { UseCase } from '../../base/use-case';
import { MetodoPagoFinancieroModel } from '../../models/configuration/metodo-pago-financiero.model';

export class GetMetodoPagoFinancieroUseCase implements UseCase<void, MetodoPagoFinancieroModel>{
	constructor(private configRepository: ConfigurationRepository) { }
	execute(): Observable<MetodoPagoFinancieroModel> {
	  return this.configRepository.getMetodoPagoFinanciero();
	}
}